import { render, staticRenderFns } from "./authenticated-with-navigation.view.vue?vue&type=template&id=bf2c52ee&scoped=true&"
import script from "./authenticated-with-navigation.view.vue?vue&type=script&lang=ts&"
export * from "./authenticated-with-navigation.view.vue?vue&type=script&lang=ts&"
import style0 from "./authenticated-with-navigation.view.vue?vue&type=style&index=0&id=bf2c52ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2c52ee",
  null
  
)

export default component.exports